var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanInterface(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82422 14.6667V10.6667H4.82422V8H8.15755V6H6.15755V2H10.8242V6H8.82422V8H12.1576V10.6667H14.1576V14.6667H9.49088V10.6667H11.4909V8.66667H5.49089V10.6667H7.49089V14.6667H2.82422ZM6.82422 5.33333H10.1576V2.66667H6.82422V5.33333ZM3.49089 14H6.82422V11.3333H3.49089V14ZM10.1576 14H13.4909V11.3333H10.1576V14Z",
    fill: "#244C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanInterface);
export default __webpack_public_path__ + "static/media/lan_interface.5334706e4dab9708eddf0ca6257dc56f.svg";
export { ForwardRef as ReactComponent };